/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
// redux
import { useSelector, shallowEqual, useDispatch } from "react-redux";
// component
import PersonTreeTable from "../../../components/PersonTreeTable";
// utils
import { findIndex, forEach, get, isEmpty, isNumber } from "lodash";
// import { sortByKey } from "../../../utils/sort";
import { setTreeDataByParts } from "../../../utils/treeData";
import { toast } from "../../../utils/toast";
import { searchEmployee } from "../../../utils/employee";
// Icon
import AddDocIcon from "../../../assets/images/person/add-doc-icon.svg";
import PencilIcon from "../../../assets/images/person/pencil-icon.svg";
import ArrowTopIcon from "../../../assets/images/person/arrow-top-icon.svg";
import ArrowBottomIcon from "../../../assets/images/person/arrow-bottom-icon.svg";
import TrashIcon from "../../../assets/images/person/trash-icon.svg";
// page
import Part from "../Component/Part";
// api
import {
  deleteParts,
  createEmployeesInParts,
  deleteEmployeesInParts,
  getPartsDetail,
  postPartsOrganize,
} from "../../../apis/companies/parts";
import {
  getStoreEmployees,
  getStoreParts,
} from "../../../store/actions";

const OrganizationView = ({ type = "division", mode, isTax = false }) => {
  const dispatch = useDispatch();
  const {
    user,
    storeParts,
    managerParts,
    storeCompany,
    storeEmployees,
    companies,
    storeManagerEmployees
  } = useSelector(
    (store) => ({
      user: store.Profile.user,
      storeCompany: store.Profile.company,
      storeParts: store.Data.parts,
      managerParts: store.Data.managerParts,
      storeEmployees: store.Data.employees,
      companies: store.Data.companies,
      storeManagerEmployees: store.Data.managerEmployees,
    }),
    shallowEqual
  );

  const [treeData, setTreeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState({
    name: "",
    employees: [],
  });
  // 직원 등록
  const [targetEmployee, setTargetEmployee] = useState([]);
  const [defaultSelected, setDefaultSelected] = useState(["company"]);
  const [selectedData, setSelectedData] = useState({});
  const [isFirst, setIsFirst] = useState(true);
  // 상세 화면 state
  const [partOpen, setPartOpen] = useState(false);
  const [formMode, setFormMode] = useState("create");

  const [employees, setEmployees] = useState([]);
  const [company, setCompany] = useState({});
  const [parts, setParts] = useState([]);

  useEffect(() => {
    (storeManagerEmployees || storeEmployees) && setEmployees(isTax ? storeManagerEmployees : storeEmployees);
    storeCompany && setCompany(isTax ? (storeCompany?.taxCompany || {}) : storeCompany);
    (!isEmpty(storeParts) || !isEmpty(managerParts)) && setParts(isTax ? managerParts : storeParts);
  }, [isTax, storeCompany, storeManagerEmployees, storeEmployees, storeParts, managerParts]);

  useEffect(() => {
    submit();

  }, [parts, companies, user, employees, company]);

  const submit = () => {
    setIsLoading(true);
    let treeData = [];

    // division
    if (!isEmpty(companies) && !isEmpty(user)) {

      treeData = [
        {
          title: company.name,
          key: "company",
          children: [
            ...setTreeDataByParts(parts),
            { title: "미지정", key: "unspecified" },
          ],
        },
      ];
    }

    setIsLoading(false);
    if (!isEmpty(treeData) && !isEmpty(employees)) {
      setTreeData(treeData);
      if (isFirst) {
        setSelectedData(treeData[0]);
        setDefaultSelected(["company"]);
        setTableData({
          name: get(treeData, "[0].title"),
          employees,
        });
      }
      setIsFirst(false);
    }
  };

  const onSelect = (keys, nodeData) => {
    const { node, selected } = nodeData;

    if (selected) {
      setSelectedData(node);

      // 회사
      if (node.key === "company") {
        setTableData({
          name: company.name,
          employees,
        });
      } else if (node.key === "unspecified") {
        // 담당자
        setTableData({
          name: node.title,
          employees: employees.filter((employee) => !employee.partIdx),
        });
      } else {
        matchEmployeeInParts(node.idx);
      }
    } else {
      setSelectedData({});
      setTableData({});
    }
  };

  // 부서에 직원 매칭
  const matchEmployeeInParts = (idx) => {
    if (!isNumber(idx)) return;
    getPartsDetail(idx, { isTax }).then((res) => {
      const { partName, companyPartEmployees } = res.data.part;
      setTableData({
        name: partName,
        employees: companyPartEmployees.map((employee) => ({
          idx: get(employee, "employeeIdx"),
          name: get(employee, "employee.name"),
          code: employees.find((e) => e.idx === get(employee, "employeeIdx")).code || "",
          gradeName: employees.find((e) => e.idx === get(employee, "employeeIdx")).gradeName || "",
          profileImg: employees.find(e => e.idx === get(employee, "employeeIdx")).profileImg || "",
          partName,
        })),
      });
    });
  };

  const handleAddAction = () => {
    if (isEmpty(selectedData)) {
      return toast.error("선택된 부서가 없습니다.");
    }
    if (selectedData.key === "unspecified") {
      return toast.error("미지정 항목 하위에 조직을 생성할 수 없습니다.");
    }
    setPartOpen(true);
    setFormMode("create");
  };
  const handleEditAction = () => {
    if (isEmpty(selectedData)) {
      return toast.error("선택된 부서가 없습니다.");
    }
    if (selectedData.key === "company") {
      return toast.error("회사명은 수정이 불가합니다.");
    }
    if (selectedData.key === "unspecified") {
      return toast.error("미지정 항목은 수정이 불가합니다.");
    }
    setPartOpen(true);
    setFormMode("modify");
  };

  const findSameLevel = (targetList, parent, newArray) => {
    forEach(targetList, data => {
      if (data.parentIdx === parent) {
        newArray.push(data);
      } else {
        if (!isEmpty(data.children)) {
          findSameLevel(data.children, parent, newArray);
        }
      }
    });
  };

  const handleTopAction = () => {
    if (isEmpty(selectedData)) return toast.error("선택된 부서가 없습니다.");
    if (!selectedData.isPart) return toast.error("부서를 선택해주세요.");
    const sameLevelParts = [];
    const parentIdx = selectedData.parentIdx;
    findSameLevel(treeData, parentIdx, sameLevelParts);
    const oldIndex = findIndex(sameLevelParts, (d) => d.key === selectedData.key);
    const newIndex = oldIndex - 1;
    if (oldIndex === 0) return;
    const newParts = moveArrayItemToNewIndex(sameLevelParts, oldIndex, newIndex);
    const body = {
      parts: newParts.map((part, idx) => ({
        partIdx: part.idx,
        parentIdx: part.parentIdx,
        sort: idx
      }))
    };
    postPartsOrganize(body).then(() => {
      dispatch(getStoreParts());
      dispatch(getStoreEmployees());
    });
  };

  const handleBottomAction = () => {
    if (isEmpty(selectedData)) return toast.error("선택된 부서가 없습니다.");
    if (!selectedData.isPart) return toast.error("부서를 선택해주세요.");
    const sameLevelParts = [];
    const parentIdx = selectedData.parentIdx;
    findSameLevel(treeData, parentIdx, sameLevelParts);
    const oldIndex = findIndex(sameLevelParts, (d) => d.key === selectedData.key);
    const newIndex = oldIndex + 1;
    const lastIndex = sameLevelParts.length - 1;
    if (oldIndex === lastIndex) return;
    const newParts = moveArrayItemToNewIndex(sameLevelParts, oldIndex, newIndex);
    const body = {
      parts: newParts.map((part, idx) => ({
        partIdx: part.idx,
        parentIdx: part.parentIdx,
        sort: idx
      }))
    };
    postPartsOrganize(body).then(() => {
      dispatch(getStoreParts());
      dispatch(getStoreEmployees());
    });
  };

  const moveArrayItemToNewIndex = (arr, old_index, new_index) => {
    let orginArr = arr;
    if (new_index >= orginArr.length) {
      let k = new_index - orginArr.length + 1;
      while (k--) {
        orginArr.push(undefined);
      }
    }
    orginArr.splice(new_index, 0, orginArr.splice(old_index, 1)[0]);
    return orginArr;
  };

  const handleDeleteAction = () => {

    if (isEmpty(selectedData)) {
      return toast.error("선택된 부서가 없습니다.");
    }
    if (selectedData.key === "company") {
      return toast.error("회사는 삭제가 불가합니다.");
    }
    if (selectedData.key === "unspecified") {
      return toast.error("미지정 항목은 삭제가 불가합니다.");
    }

    if (!isEmpty(selectedData.children)) {
      return toast.error("하위 부서가 존재합니다.");
    }

    deleteParts(selectedData.idx).then(() => {
      dispatch(getStoreParts());
      dispatch(getStoreEmployees());
      setSelectedData({});
      setTableData({});
    });
  };

  const IconButtons = [
    { icon: AddDocIcon, action: handleAddAction },
    { icon: PencilIcon, action: handleEditAction },
    { icon: ArrowTopIcon, action: handleTopAction },
    { icon: ArrowBottomIcon, action: handleBottomAction },
    { icon: TrashIcon, action: handleDeleteAction },
  ];

  const handleAddEmployee = () => {
    if (get(selectedData, "key") === "company") {
      return toast.error("부서를 선택해주세요.");
    }
    if (get(selectedData, "key") === "unspecified") {
      return toast.error("부서를 선택해주세요.");
    }
    searchEmployee(
      (employees) => {
        setTargetEmployee(employees);
      },
      targetEmployee,
      { isTax }
    );
  };

  const handleDeleteEmployee = (data) => {
    deleteEmployeesInParts(selectedData.idx, data.idx).then(() => {
      matchEmployeeInParts(selectedData.idx);
      dispatch(getStoreEmployees());
    });
  };

  useEffect(() => {
    if (!isEmpty(targetEmployee) && !isEmpty(selectedData)) {
      const promiseList = [];
      forEach(targetEmployee, employee => {
        promiseList.push(createEmployeesInParts(selectedData.idx, {
          type: 2,
          employeeIdx: employee.idx,
          isTax
        }));
      });

      Promise.all(promiseList)
        .then(() => {
          matchEmployeeInParts(selectedData.idx);

        }).finally(() => {
          setTargetEmployee([]);
          dispatch(getStoreEmployees());
        });
    }
  }, [targetEmployee, selectedData]);

  return (
    <>
      <PersonTreeTable
        type={type}
        mode={mode}
        submit={submit}
        isLoading={isLoading}
        treeData={treeData}
        setTreeData={setTreeData}
        tableData={tableData}
        onSelect={onSelect}
        defaultSelectedKeys={defaultSelected}
        selectedData={selectedData}
        buttons={IconButtons}
        handleAddEmployee={handleAddEmployee}
        handleDeleteEmployee={handleDeleteEmployee}
        isTax={isTax}
      />
      <Part
        open={partOpen}
        setOpen={setPartOpen}
        mode={formMode}
        list={selectedData}
        submit={matchEmployeeInParts}
        isTax={isTax}
      />
    </>
  );
};

export default OrganizationView;
